/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropTwitchVodResponse
 */
export interface DropTwitchVodResponse {
    /**
     * 
     * @type {string}
     * @memberof DropTwitchVodResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchVodResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchVodResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchVodResponse
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchVodResponse
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof DropTwitchVodResponse
     */
    durationSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof DropTwitchVodResponse
     */
    viewCount: number;
}

/**
 * Check if a given object implements the DropTwitchVodResponse interface.
 */
export function instanceOfDropTwitchVodResponse(value: object): value is DropTwitchVodResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('durationSeconds' in value) || value['durationSeconds'] === undefined) return false;
    if (!('viewCount' in value) || value['viewCount'] === undefined) return false;
    return true;
}

export function DropTwitchVodResponseFromJSON(json: any): DropTwitchVodResponse {
    return DropTwitchVodResponseFromJSONTyped(json, false);
}

export function DropTwitchVodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropTwitchVodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'url': json['url'],
        'thumbnailUrl': json['thumbnailUrl'],
        'createdAt': json['createdAt'],
        'durationSeconds': json['durationSeconds'],
        'viewCount': json['viewCount'],
    };
}

export function DropTwitchVodResponseToJSON(json: any): DropTwitchVodResponse {
    return DropTwitchVodResponseToJSONTyped(json, false);
}

export function DropTwitchVodResponseToJSONTyped(value?: DropTwitchVodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'url': value['url'],
        'thumbnailUrl': value['thumbnailUrl'],
        'createdAt': value['createdAt'],
        'durationSeconds': value['durationSeconds'],
        'viewCount': value['viewCount'],
    };
}

